import React, { memo } from 'react';
import { Modal } from 'antd';
import PropList from './PropList';
import { ProposalListResponse } from '../../services/proposal';

export type PropListModalProps = {
  visible: boolean;
  onCancel: () => void;
  onSelect: (item: ProposalListResponse) => void;
};

const PropListModal = (props: PropListModalProps) => {
  const { visible, onCancel, onSelect } = props;

  return (
    <Modal
      visible={visible}
      title="Proposal Search"
      footer={null}
      onCancel={onCancel}
      width={1200}
    >
      <PropList onSelect={onSelect} />
    </Modal>
  );
};

export default memo(PropListModal);
